import { useState } from 'react';
import { AppLayout } from './components/layout/AppLayout';
import { LicenseConfigurator } from './components/LicenseConfigurator';
import { CostCalculator } from './components/calculator/CostCalculator';
import { HowToBuy } from './components/HowToBuy';

type Tab = 'compare' | 'calculator' | 'howtobuy';

const tabs: { id: Tab; label: string }[] = [
  { id: 'compare', label: 'Compare Plans' },
  { id: 'calculator', label: 'Cost Calculator' },
  { id: 'howtobuy', label: 'How to Buy' },
];

function App() {
  const [activeTab, setActiveTab] = useState<Tab>('compare');

  return (
    <div className="min-h-screen bg-gray-50">
      <AppLayout>
        <div className="mb-6">
          <div className="flex gap-2 border-b border-gray-200">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 font-medium text-sm transition-colors border-b-2 ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'compare' && <LicenseConfigurator />}
        {activeTab === 'calculator' && <CostCalculator />}
        {activeTab === 'howtobuy' && <HowToBuy />}
      </AppLayout>
    </div>
  );
}

export default App;